module.exports = __webpack_public_path__ + "img/Zhang_Yue.e7593aa3.png";